// eslint-disable-next-line import/extensions -- package's exports map requires the .js suffix
import { shouldPolyfill } from '@formatjs/intl-segmenter/should-polyfill.js'
import { getBadActorFlagKey, setBadActorData } from './badActorStore'

const spaceRegex = /\s/gimu

/**
 * Checks a given string for the presence of too many spaces and updates the bad actor data accordingly.
 *
 * @param {string} string - The string to check for too many spaces.
 * @returns {boolean} - Returns true if the string has more spaces than the configured threshold, false otherwise.
 */
export default async function checkForTooManySpaces(string) {
  if (typeof string !== 'string') {
    throw new Error('Argument must be a string')
  }
  const key = 'checkForTooManySpaces'
  if (shouldPolyfill()) {
    // eslint-disable-next-line import/extensions -- package's exports map requires the .js suffix
    await import('@formatjs/intl-segmenter/polyfill-force.js')
  }

  const keyData = await getBadActorFlagKey(key)

  if (keyData?.enabled) {
    const segmenter = new Intl.Segmenter()
    const internationalizedString = Array.from(segmenter.segment(string, { granularity: 'word' }))
      .map((segment) => segment.segment)
      .join('')
    const results = internationalizedString.match(spaceRegex) || []
    const data = {}
    data.count = results.length
    data.pass = data.count <= keyData.threshhold
    data.editedTerm = string
    setBadActorData(key, data)
    return results.length > keyData.threshhold
  }
  return false
}
